import { getDefaultDashboardData } from '@/dashboard/features/dashboardCore/constants/dashboard.data';
import { GRID_LAYOUT_OPTION } from '@/dashboard/features/dashboardLayout/domain/baseGridLayout.constants';
import { DashboardPort } from './dashboard.ports';

export const convertToDashboardData: DashboardPort['convertToDashboardData'] = (dashboardDto) => {
  const defaultData = getDefaultDashboardData();
  return {
    dashboardId: dashboardDto.dashboardId ?? defaultData.dashboardId,
    dashboardGroupId: dashboardDto.dashboardGroupId ?? defaultData.dashboardGroupId,
    dashboardName: dashboardDto.dashboardName ?? defaultData.dashboardName,
    description: dashboardDto.description,
    image: dashboardDto.image,
    preset: dashboardDto.preset ?? defaultData.preset,
    shared: dashboardDto.shared ?? defaultData.shared,
    sharing: dashboardDto.sharing ?? defaultData.sharing,
    startScreen: dashboardDto.startScreen ?? defaultData.startScreen,
    favoriteId: dashboardDto.favoriteId,
    createUser: dashboardDto.createUser ?? defaultData.createUser,
    creator: {
      name: dashboardDto.createUserName ?? defaultData.creator.name,
      activeId: dashboardDto.createUserActiveId ?? defaultData.creator.activeId,
      roleId: dashboardDto.createUserRole ?? defaultData.creator.roleId,
      profileImage: dashboardDto.createUserProfileImage ?? defaultData.creator.profileImage,
    },
    lastModified: dashboardDto.lastModified,
    featuredReport: dashboardDto.featuredReport ?? defaultData.featuredReport,
    customReport: dashboardDto.customReport ?? defaultData.customReport,
    menuPaths: dashboardDto.menuPaths,
    analysisMenuPaths: dashboardDto.analysisMenuPaths,
    dashboardOption: dashboardDto.dashboardOption
      ? JSON.parse(dashboardDto.dashboardOption)
      : defaultData.dashboardOption,
    iconId: dashboardDto.iconId ?? defaultData.iconId,
  };
};

export const convertToDeleteDashboardsDto: DashboardPort['convertToDeleteDashboardsDto'] = (
  dashboardData,
) => {
  return {
    customReport: dashboardData.customReport,
    dashboardGroupId: -1,
    dashboardId: dashboardData.dashboardId,
    dashboardName: dashboardData.dashboardName,
    dashboardOption: JSON.stringify(dashboardData.dashboardOption),
    deleted: true,
    description: dashboardData.description,
    featuredReport: dashboardData.featuredReport,
    image: dashboardData.image,
    preset: dashboardData.preset,
    startScreen: dashboardData.startScreen,
  };
};

export const convertToEditDashboardRequestDto: DashboardPort['convertToEditDashboardRequestDto'] = (
  editDashboardRequest,
  option = { overrideDefaultOption: true },
) => {
  const dashboardOption = {
    gridLayoutOption: option.overrideDefaultOption ? GRID_LAYOUT_OPTION : undefined,
    ...editDashboardRequest.dashboardOption,
  };

  return {
    customReport: editDashboardRequest.customReport,
    dashboardGroupId: editDashboardRequest.dashboardGroupId,
    dashboardId: editDashboardRequest.dashboardId,
    dashboardName: editDashboardRequest.dashboardName,
    dashboardOption: JSON.stringify(dashboardOption),
    deleted: false,
    description: editDashboardRequest.description,
    featuredReport: editDashboardRequest.featuredReport,
    image: editDashboardRequest.image,
    preset: editDashboardRequest.preset,
    startScreen: editDashboardRequest.startScreen,
  };
};

export const convertToUpdateDashboardFavoriteRequestDto: DashboardPort['convertToUpdateDashboardFavoriteRequestDto'] =
  (updateFavoriteRequest) => {
    return {
      dashboardId: updateFavoriteRequest.dashboardId,
      deleted: updateFavoriteRequest.deleted,
      favoriteId: updateFavoriteRequest.favoriteId,
    };
  };

export const convertToUpdateDashboardGroupRequestDto: DashboardPort['convertToUpdateDashboardGroupRequestDto'] =
  (updateGroupRequest) => {
    return {
      dashboardId: updateGroupRequest.dashboardId,
      dashboardGroupId: updateGroupRequest.dashboardGroupId,
    };
  };

export const convertToDashboardGroup: DashboardPort['convertToDashboardGroup'] = (
  dashboardGroupDto,
) => {
  return {
    dashboardGroupName: dashboardGroupDto.dashboardGroupName ?? '',
    dashboardGroupId: dashboardGroupDto.dashboardGroupId,
  };
};
